// 在家状态文案（P6-POLISH-ENG-002 / 设计规格 design/ux/07-polish-ux-spec.md §C / 文案 06 §3）。
//
// 替换 MainView 里写死的两句（「它在房间里转来转去」/「又在窗边趴着了」）。
//
// 两条纪律，实现时勿混：
//   1. **视角**是旁白第三人称（"它"），**不是**小狗第一人称。小狗说话只出现在揭晓气泡
//      （DOG_NOTES / EMPTY_HANDS_NOTES）里，本池刻意与那两个池区分。
//   2. **零随机、零新存档字段** —— 由 tripCount 取模派生，刷新可复现、可单测。
//
// 为什么按 tripCount 而不是"每次进 home 换一条"：后者会在同一趟旅行期间反复进出时跳变，
// 且在 React StrictMode 双挂载下会多计；"每回一次家换一句话"既和玩家的实际行为节律咬合，又无需任何状态。
import type { SaveDataV1 } from '../save/types';

// 池 A · 还没出过门（isFirstTripDone === false）。
// C-A1 沿用现有首句，不能删（最早的那句，玩家/老板都熟悉）。
const POOL_FIRST: readonly string[] = [
  '它在房间里转来转去',
  '它在门口闻来闻去',
  '它坐在地板上，看着门',
];

// 池 B · 出过门之后（isFirstTripDone === true）。
// C-B1 沿用现有「又在窗边趴着了」，作为池 B 的第 1 条。
const POOL_AFTER: readonly string[] = [
  '又在窗边趴着了',
  '它趴在阳光里，睡得很浅',
  '看见你，它抬了抬头',
  '它在地毯上团成一团',
  '它睡着了，耳朵偶尔动一下',
  '它朝着门的方向趴着',
  '它伸了个懒腰，又趴下了',
  '它把上次带回来的挪了挪',
];

/**
 * 取一句在家状态文案。
 * - 池的选择只看 `isFirstTripDone`（有没有出过门）；
 * - 句的选择只看 `tripCount`（每回一次家 → tripCount +1 → 换下一句）。
 * tripCount 极大时也恒落在池内（模运算），无需特判。
 */
export function homeStatusText(isFirstTripDone: boolean, tripCount: number): string {
  const pool = isFirstTripDone ? POOL_AFTER : POOL_FIRST;
  return pool[tripCount % pool.length] ?? pool[0] ?? '';
}

/** 便捷重载：直接吃存档（save 为 null 时返回空串，由调用方决定要不要渲染）。 */
export function homeStatusTextFromSave(save: SaveDataV1 | null): string {
  if (!save) return '';
  return homeStatusText(save.stats.isFirstTripDone, save.stats.tripCount);
}
